import { useEffect, useRef } from "react";
import { useState } from "react";
import { DialogSearch } from "./DialogSearch";
import { isArrayEmpty } from "../../../helpers/ObjectHelpers";
import moment from "moment";
import PilotApiRepository from "../../../../repositories/api/PilotApiRepository";
import { BusySpinner } from "../../overlay/components/Busy";
import { getElementsByClassName } from "../../../helpers/ElementHelpers";
import parse from 'html-react-parser';
import { IconColors } from "../../../../services/SystemNames";
import Icons from "../../icons/Icons";
import Overlay from "../../overlay/Overlay";
import { Card } from "../../card/Card";

export const DialogPilotagePicker = ({
    properties
}) => {

    const [searchResult, setSearchResult] = useState([]);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const [canFetchMore, setCanFetchMore] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [searchText, setSearchText] = useState('');

    const componentRef = useRef({
        timer: null
    });
    const { current: localRef } = componentRef;

    useEffect(() => {
        initializeAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const elem = getScrollElement();
        elem.addEventListener("scroll", onScroll);
        return () => {
            const elem = getScrollElement();
            if (!elem) return;
            elem.removeEventListener("scroll", onScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onScroll]);

    return (
        <>
            <DialogSearch
            properties={{
                ...properties,
                className: "dialog-std",
                placeholder: "S&oslash;k p&aring; oppdragsnummer/fart&oslash;y...",
                size: "large",
                mode: "search-content",
                onSearch: onSearch,
                isBusy: isBusy
            }}>
            <div className="k-d-grid k-gap-2">
                    {
                        searchResult.map((item, index) =>
                            <div key={index}>
                                <Card
                                    id={item.pilotageID}
                                    title={item.shipName}
                                    subTitle={moment(item.fromTime).format("DD.MM HH:mm")}
                                    borderColor={item.pilotagePilotStatus === "COMPLETED" ? "var(--pp-status-completed-border)" : "var(--pp-status-confirmed-border)"}
                                    showIndicator={true}
                                    indicatorPrimaryColor={item.pilotagePilotStatus === "COMPLETED" ? "var(--pp-status-completed-border)" : "var(--pp-status-confirmed-border)"}
                                    onClick={() => {
                                        if (!properties.onClick) return;
                                        properties.onClick(item);
                                    }}>
                                    <div className="pp-card-body-locations">
                                        <div>
                                            <div>
                                                {parse(item.pilotageFromLocationName)}
                                            </div>
                                            <div>
                                                {item.pilotageNo}
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <Icons iconName="arrowTo" dimensions={20} color={IconColors.Primary} />
                                            </div>
                                            <div>
                                                &nbsp;{parse(item.pilotageToLocationName)}
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        )
                    }
                </div>
            {
                isFetchingMore &&
                <div className="fetching-more">
                    <BusySpinner dimensions={40} type="oval" />
                </div>
            }
            </DialogSearch>
            <Overlay show={isBusy}  />
        </>
    );

    async function initializeAsync(fetchMore = false, forceReset = false, searchText = "") {

        if (isFetchingMore || isBusy) return;
        
        if (fetchMore) {
            setIsFetchingMore(true);
        } else {
            setIsBusy(true);
        }
        
        const toTime = getToTime(forceReset);
        const response = await PilotApiRepository.searchPilotagesAsync(toTime, 20, searchText);
        
        if (response.ok) {
            const data = await response.json();
            if (searchResult.length === 0 || forceReset) {
                setSearchResult(data);
            } else {
                data.forEach((item) => {
                    searchResult.push(item);
                });
            }

            if (fetchMore) {
                setIsFetchingMore(false);
            }

            setCanFetchMore(data.length > 0);
        }

        setIsBusy(false);
    }

    function onSearch(e) {
        setSearchText(e);

        clearTimeout(localRef.timer);

        localRef.timer = setTimeout(() => {
            initializeAsync(false, true, e);
        }, 750);
    }

    function getScrollElement() {
        const elems = getElementsByClassName("k-dialog-content");
        if (isArrayEmpty(elems)) return null;
        return elems[0];
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    function onScroll(e) {
        if (!canFetchMore) return;

        const elem = getScrollElement();
        if (!elem) return;

        if (!((elem.scrollHeight - elem.scrollTop) === elem.offsetHeight)) return;

        initializeAsync(true, false, searchText);
    }

    function getToTime(forceReset = false) {
        if (isArrayEmpty(searchResult) || forceReset) return moment();

        return moment(
            searchResult[
                searchResult.length - 1
            ].fromTime,
        ).add(-1, "S");
    }
};

